///////////////////////////////
///// Offer CMS Ticket Links
////////////////////////////

/**
 * CMS Ticket Link selections for the dropdown menu for offers
 * @type array
 */
export const ticketLinkSelections = [
  {
    name: 'General Onsale',
    id: 1,
  },
  {
    name: 'General Onsale ADA',
    id: 2,
  },
  {
    name: 'Pre Sale',
    id: 3,
  },
  {
    name: 'Pre Sale ADA',
    id: 4,
  },
  {
    name: 'Separate Promotion',
    id: 5,
  },
];

export const promotionStatuses = [
  {
    value: 1,
    key: 1,
    text: 'Buy Offer',
  },
  {
    value: 2,
    key: 2,
    text: 'Download',
  },
  {
    value: 3,
    key: 3,
    text: 'Sold Out',
  },
  {
    value: 4,
    key: 4,
    text: 'More Info',
  },
  {
    value: 5,
    key: 5,
    text: 'Select Tickets',
  },
  {
    value: 6,
    key: 6,
    text: 'Buy Admission',
  },
];

export const mediaTypes = {
  PRIMARY_LANDSCAPE: '17',
  PRIMARY_SQUARE: '18',
  FACEBOOK: '86',
};

export const createCMSText = {
  CREATE: 'Create CMS Event',
  CANCEL: 'Cancel CMS Event Creation',
};
export const CMS_EVENT_OVERLAP_WARNING =
  'Warning! There is an existing event at this venue at this time. Do you want to continue and save the event anyway?';
export const NO_CMS_EVENT_WARNING =
  'Warning! Template event doesn`t have AXS VENUEID. Please select a valid template';
export const imageLength = 23;



// WEBPACK FOOTER //
// ./src/common/constants/index.js